import { defineStore } from "pinia";
import { ref } from "vue";


export const useLogoStore = defineStore("logo", () => {
	const default_logo_path = import.meta.env.VITE_DEFAULT_LOGO;
	const news_logo_path = import.meta.env.VITE_NEWS_LOGO;
	console.log(news_logo_path)
	const current_logo = ref(default_logo_path)
	const set_news = () => {
		current_logo.value = news_logo_path;
	}
	const reset = () => {
		current_logo.value = default_logo_path;
	}
	return {
		current_logo, set_news, reset
	}
})